// @flow
import { cnpj as CNPJ, cpf as CPF } from 'cpf-cnpj-validator';
import _ from 'lodash';
import { ie } from 'br-validations';
import moment from 'moment';

const _trim = (value: ?string) => (value || '').trim();
const phone = (value: string) => {
  const trimValue = _trim(value);
  if (!trimValue) {
    return 'Telefone é obrigatório';
  } else {
    return '';
  }
};

const address = {
  name: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) {
      return 'Nome é obrigatório';
    } else if (trimValue.length > 100) {
      return 'Nome muito longo. Max 100 letras';
    } else {
      return '';
    }
  },

  addressLine1: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) {
      return 'Endereço é obrigatório';
    } else if (trimValue.length > 100) {
      return 'Nome muito longo. Max 100 letras';
    } else if (trimValue.length < 5) {
      return 'Nome muito curto.';
    } else {
      return '';
    }
  },

  addressLine2: (value: string) => {
    const trimValue = _trim(value);
    if (trimValue.length > 100) {
      return 'Complemento muito longo. Max 100 letras';
    } else {
      return '';
    }
  },

  city: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) {
      return 'Cidade é obrigatório';
    } else if (trimValue.length > 30) {
      return 'Nome muito longo. Max 40 letras';
    } else {
      return '';
    }
  },

  zipcode: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) {
      return 'CEP é obrigatório';
    } else if (value.replace(/-|\.|\s/g, '').length !== 8) {
      return 'CEP são 8 números';
    } else if (value[0] !== '4') {
      return 'Fora da area de cobertura';
    } else {
      return '';
    }
  },

  neighborhood: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) {
      return 'Bairro é obrigatório';
    } else if (trimValue.length > 30) {
      return 'Nome muito longo. Max 40 letras';
    } else {
      return '';
    }
  },
  telephone: phone,
  pointOfReference: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) {
      return 'Ponto de referência é obrigatório';
    } else if (trimValue.length > 100) {
      return 'Muito longo. Máximo 100 letras';
    } else {
      return '';
    }
  },

  cnpj: (value: string) => {
    if (value.length === 0) {
      return 'Campo é obrigatório';
    } else if (value.replace(/[\.\-\/\s]/g, '').length !== 14) {
      return 'O CNPJ deve ter 14 caracteres';
    } else if (!CNPJ.isValid(value)) {
      return 'CNPJ inválido';
    } else {
      return '';
    }
  },
  ieCompany: (value: string) => {
    if (!value) return '';
    if (
      !(
        value.replace(/-|\.|\s|\//g, '').length === 8 ||
        value.replace(/-|\.|\s|\//g, '').length === 9
      )
    ) {
      // period, space and dashes do not count
      return 'Inscrição Estadual são 8 ou 9 números';
    } else if (!ie('BA').validate(value)) {
      return 'Inscrição Estadual inválida';
    } else {
      return '';
    }
  },

  company: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) {
      return 'Campo é obrigatório';
    } else if (trimValue.length > 50) {
      return 'Nome muito longo';
    } else {
      return '';
    }
  },

  residenceNumber: (value: string) => {
    const trimValue = _trim(value);
    if (!trimValue) return 'Número de residência é obrigatório';
    if (trimValue.length > 10) return 'Muito longo. Max 10 digitos';
    return '';
  },

  residenceType: (value: string) => {
    if (!value) return 'Tipo de residência é obrigatório';
    if (value !== 'apartment' && value !== 'house')
      return 'Tipo de residência inválido';
    return '';
  },

  residenceData: (value: string) => {
    const trimValue = _trim(value);
    if (trimValue.length > 100) return 'Muito longo. Max 100 letras';
    return '';
  },

  houseNumber: (value: ?string) => {
    const trimValue = _trim(value);
    if (!trimValue) return 'Número do endereço é obrigatório';
    if (trimValue === 'S/N') return '';
    if (trimValue.length > 10) return 'Muito longo. Max 10 digitos';
    return '';
  },
};

const creditCard = {
  name: (value: string) => {
    if (!value) {
      return 'Nome é obrigatório';
    } else if (value.split(' ').length < 2) {
      return 'Nome incorreto. Verifique o cartão';
    } else if (value.length > 100) {
      return 'Nome muito longo. Max 100 letras';
    } else {
      return '';
    }
  },

  number: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (!value.match(/^\d+$/)) {
      return 'Cartão deve conter apenas números';
    } else if (value.length <= 10 || value.length >= 20) {
      return 'O número deve conter entre 10 e 20 digitos';
    } else {
      return '';
    }
  },

  cvv: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (!value.match(/^\d+$/)) {
      return 'CVV deve conter apenas números';
    } else if (value.length < 2 || value.length > 5) {
      return 'O CVV deve conter entre 2 e 5 dígitos';
    } else {
      return '';
    }
  },

  year: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (!value.match(/^\d+$/)) {
      return 'Ano deve conter apenas números';
    } else if (value.length !== 4 && value.length !== 2) {
      return 'O ano deve ter 2 ou 4 dígitos. Ex: 2025';
    } else if (
      value.length === 4 &&
      (parseInt(value, 10) < 2017 || parseInt(value, 10) > 2100)
    ) {
      return 'Ano inválido';
    } else if (value.length === 2 && parseInt(value, 10) < 17) {
      return 'Ano inválido';
    } else {
      return '';
    }
  },

  month: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (!value.match(/^\d+$/)) {
      return 'Mês deve conter apenas números';
    } else if (value.length !== 2) {
      return 'O mês deve ter 2 dígitos. Ex: 04=Abril.';
    } else if (parseInt(value, 10) < 1 || parseInt(value, 10) > 12) {
      return 'Mês deve ser número entre 1 e 12';
    } else {
      return '';
    }
  },
};

const user = {
  firstName: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (value.length > 30) {
      return 'Nome muito longo';
    } else {
      return '';
    }
  },

  lastName: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (value.length > 30) {
      return 'Nome muito longo';
    } else {
      return '';
    }
  },

  cpf: (value: string) => {
    if (value.length === 0) {
      // CPF is missing or invalid?
      return 'Campo é obrigatório';
    } else if (value.replace(/-|\.|\s/g, '').length !== 11) {
      // period, space and dashes do not count
      return 'CPF são 11 números';
    } else if (!CPF.isValid(value)) {
      return 'CPF inválido';
    } else {
      return '';
    }
  },

  referralCode: (value: string) => {
    return '';
  },

  email: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (/\s/.test(value)) {
      return 'O email não pode conter espaços em branco';
    } else if (!/^[^@\s]+@(?:[-a-z0-9]+\.)+[a-z]{2,}$/i.test(value)) {
      return 'Email inválido';
    } else {
      return '';
    }
  },

  password: (value: string) => {
    if (!value) {
      // Password is missing or invalid?
      return 'Campo é obrigatório';
    } else if (value.length < 6) {
      return 'Senha muito curta. Mínimo de 6 caracteres';
    } else if (value.length > 50) {
      return 'Senha muito longa. Máx de 50 caracteres';
    } else {
      return '';
    }
  },

  passwordConfirmation: (value: string, otherValue: string) => {
    if (!value) {
      // Confirmation password is mandatory
      return 'Campo é obrigatório';
    } else if (value !== otherValue) {
      // Confirmation password has to match password

      return 'Senha e confirmação não são iguais';
    } else {
      return '';
    }
  },

  birthdate: (value: string) => {
    const maxAgeInYears = 120;
    const minAgeInYears = 13;
    const today = new Date();
    const userBirthdate = moment(value, 'DD/MM/YYYY');

    if (!userBirthdate.isValid()) return 'Data de nascimento inválida';
    if (userBirthdate.isAfter(today)) return 'Data deve ser no passado';

    const isUserOlderThanMaxAge =
      moment(today).diff(userBirthdate, 'years') > maxAgeInYears;
    if (isUserOlderThanMaxAge) return 'Deve ter no máximo 120 anos';

    const isUserYoungerThanMinAge =
      moment(today).diff(userBirthdate, 'years') < minAgeInYears;
    if (isUserYoungerThanMinAge) return 'Deve ter pelo menos 13 anos';

    return '';
  },

  acceptedTerms: (value: string) => {
    if (!value) {
      // Accepted terms and conditions
      return 'Favor aceitar os termos de uso';
    } else {
      return '';
    }
  },
};

const blend = {
  name: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (value.length > 30) {
      return 'Nome muito longo. Max 30 letras';
    } else {
      return '';
    }
  },
  observation: (value: string) => {
    if (value.length > 140) {
      return 'Descrição muito longa. Max 140 letras';
    } else {
      return '';
    }
  },

  blendItems: (value: Item[]) => {
    if (_.isEmpty(value)) {
      return 'O blend precisa ter ao menos 1 item';
    } else {
      return '';
    }
  },
};

const giftCard = {
  name: (value: string) => {
    if (!value) {
      return 'Nome é obrigatório';
    } else if (value.length > 100) {
      return 'Nome muito longo. Max 100 letras';
    } else {
      return '';
    }
  },
  email: (value: string) => {
    if (!value) {
      return 'Campo é obrigatório';
    } else if (/\s/.test(value)) {
      return 'O email não pode conter espaços em branco';
    } else if (!/^[^@\s]+@(?:[-a-z0-9]+\.)+[a-z]{2,}$/i.test(value)) {
      return 'Email inválido';
    } else {
      return '';
    }
  },
  amount: (value: string) => {
    if (!value) {
      return 'Valor é obrigatório';
    } else {
      return '';
    }
  },
  sendAt: (value: string) => {
    if (!value) {
      return 'Data de envio é obrigatória';
    }
    const selectedDate = new Date(value);
    const now = new Date();

    if (selectedDate <= now) {
      return 'A data e hora de envio devem ser no futuro';
    } else {
      return '';
    }
  },
};

const validationHelpers = {
  phone,
  address,
  creditCard,
  user,
  blend,
  giftCard,
};

export default validationHelpers;
